// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4548":"a07aca43d2c9bd9f","6785":"7bc685981ac9f22b","7116":"4bed2b06e7e72672","9626":"54856d642e834512"}[chunkId] + ".css";
};